import React from 'react';
import { Typography } from '@mui/material';
import DataGridMultiBrokerGroup from '@/components/table/DataGridComponents/DataGridMultiBrokerGroup';
import { OwnerCellData } from '@/components/tables/OwnerCell';
import { formatDateTime, getDateSortValue } from './helpers';

export const columns = [
	{
		field: 'name',
		headerName: 'Username',
		flex: 1,
		minWidth: 180,
		display: 'flex',
		hideable: false,
		renderCell: ({ row }) => (
			<OwnerCellData userId={row.id} email={row.email} color='text.primary' />
		),
	},
	{
		field: 'primaryEmail',
		headerName: 'Primary email',
		flex: 1.2,
		minWidth: 200,
		hideable: false,
	},
	{
		field: 'phone',
		headerName: 'Phone',
		width: 140,
		hideable: true,
	},
	{
		field: 'role',
		headerName: 'Role',
		width: 160,
		hideable: true,
	},
	{
		field: 'brokerGroupIds',
		headerName: 'Broker Group',
		flex: 1.2,
		minWidth: 180,
		sortable: false,
		display: 'flex',
		hideable: true,
		renderCell: ({ row }) =>
			row.brokerGroupIds?.length ? (
				<DataGridMultiBrokerGroup brokerGroupIds={row.brokerGroupIds} showAdmin={false} />
			) : (
				<Typography variant='body1'>-</Typography>
			),
	},
	{
		field: 'lastUpdated',
		headerName: 'Last updated',
		width: 190,
		display: 'flex',
		type: 'number',
		headerAlign: 'left',
		hideable: true,
		valueGetter: (_, row) => getDateSortValue(row.lastUpdated),
		renderCell: ({ row }) => formatDateTime(row.lastUpdated),
	},
	{
		field: 'lastUpdatedBy',
		headerName: 'Last updated by',
		flex: 1,
		minWidth: 180,
		sortable: false,
		display: 'flex',
		hideable: true,
		renderCell: ({ row }) =>
			row.lastUpdatedBy ? (
				// lastUpdatedBy is the performer's Firestore user doc id.
				<OwnerCellData userId={row.lastUpdatedBy} color='text.primary' />
			) : (
				<Typography variant='body1'>-</Typography>
			),
	},
].map((column) => ({ ...column, disableColumnMenu: !column.hideable }));
